"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBPASS_STRATEGY = void 0;
exports.WEBPASS_STRATEGY = 'webpass';
